module.exports = __webpack_public_path__ + "hfzs.png?6bb11d18e4d18b8e706d86512413436f";


//////////////////
// WEBPACK FOOTER
// ./static/assets/hfzs.png
// module id = 529
// module chunks = 0